export function LocationSearchNotFoundMessages(props: {
  searchedString: string;
  fetching: boolean;
}) {
  const { searchedString, fetching } = props;

  if (fetching) return <div>Searching...</div>;
  if (searchedString && !fetching) return <div>Location not found</div>;
  return <div>Search by Address, City or State</div>;
}
